<template>
  <div class="container">
    <topHeader title="账单"></topHeader>
    <div class="filter-content">
      <div class="date-filter" @click="handleChangeDate">
        <span>{{ thisMonth }}</span>
        <span>月</span>
        <img class="arrow-img" src="../../assets/images/bottomImg.png" alt="" />
      </div>
      <div class="status-filter" @click="handleChangeStatus">
        <div class="status-item">
          <div>{{ thisStatus }}</div>
          <img
            class="arrow-img"
            src="../../assets/images/bottomImg.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="recharge-content">
      <van-list
        v-if="historyList && historyList.length > 0"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div
          v-if="historyList && historyList.length > 0"
          class="history-content"
          style="overflow: auto"
        >
          <div v-for="(item, index) in historyList" :key="index" class="item">
            <div class="time">
              <div class="label">
                {{ item.payTime ? toDate(item.payTime) : item.createTime }}
              </div>
              <img
                v-if="
                  item.verifyStatus !== 2 &&
                  item.verifyStatus !== 0 &&
                  item.refundStatus !== 5 &&
                  item.type !== 3 &&
                  item.refundStatus !== 3
                "
                src="@/assets/images/rightImg.png"
                alt=""
                @click="toDetail(item)"
              />
            </div>
            <div class="count">
              <div class="label">
                {{ item.type === 1 ? '充值金额' : '退款金额' }}
              </div>
              <div :class="item.type === 1 ? 'value' : 'value refund'">
                {{
                  item.verifyStatus === 0
                    ? getMoney(
                        (item.amountApplication === null
                          ? item.amount
                          : item.amountApplication) / 100
                      )
                    : item.type === 1
                    ? '+' + getMoney(item.amount / 100)
                    : getMoney(item.amount / 100)
                }}
              </div>
            </div>
            <div class="status">
              <div class="label">
                {{ item.type === 1 ? '充值状态' : '退款状态' }}
              </div>
              <div
                :class="
                  item.type === 3
                    ? 'value success'
                    : item.type === 1
                    ? item.status === 1
                      ? 'value fail'
                      : item.status === 2
                      ? 'value unknown'
                      : 'value success'
                    : item.verifyStatus === -1
                    ? item.refundStatus === 3
                      ? 'value ing'
                      : item.refundStatus === 4
                      ? 'value success'
                      : 'value fail'
                    : item.verifyStatus === 0
                    ? 'value ing'
                    : item.verifyStatus === 1
                    ? item.refundStatus === 3
                      ? 'value ing'
                      : item.refundStatus === 4
                      ? 'value success'
                      : 'value fail'
                    : 'value reject'
                "
              >
                {{
                  item.type === 3
                    ? '退款成功'
                    : item.type === 1
                    ? item.status === 1
                      ? '充值失败'
                      : item.status === 2
                      ? '未知'
                      : '充值成功'
                    : item.verifyStatus === -1
                    ? item.refundStatus === 3
                      ? '退款中'
                      : item.refundStatus === 4
                      ? '退款成功'
                      : '退款失败'
                    : item.verifyStatus === 0
                    ? '审核中'
                    : item.verifyStatus === 1
                    ? item.refundStatus === 3
                      ? '退款中'
                      : item.refundStatus === 4
                      ? '退款成功'
                      : '退款失败'
                    : '审核拒绝'
                }}
              </div>
            </div>
          </div>
        </div>
      </van-list>
      <div
        v-else
        style="
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 100%;
          width: 100%;
        "
      >
        <img
          style="width: 280px; height: 150px; margin: 0px auto 20px"
          src="@/assets/images/noneImg.png"
          alt=""
        />
        <div style="text-align: center; color: #666666; font-size: 16px">
          暂无内容
        </div>
      </div>
    </div>
    <div>
      <van-popup v-model="show" position="bottom" :style="{ height: '45%' }">
        <van-datetime-picker
          v-model="currentDate"
          type="year-month"
          title=""
          :min-date="minDate"
          :max-date="maxDate"
          :formatter="formatter"
          confirm-button-text="确定"
          @confirm="handleSelectDate"
          @cancel="handleCancelDate"
        />
      </van-popup>

      <van-popup
        v-model="showStatus"
        position="bottom"
        :style="{ height: '45%' }"
      >
        <van-picker
          title
          show-toolbar
          :columns="columns"
          :default-index="0"
          @confirm="onConfirm"
          @cancel="onCancel"
        />
      </van-popup>
    </div>
  </div>
</template>

<script>
import cancel from '@/assets/cancel.png';
import { getHistory } from '@/api/api';
import { toDate, getMoney } from '@/utils/util';
import topHeader from '@/components/topHeader';

export default {
  name: 'History',
  components: { topHeader },
  data() {
    return {
      cancel,
      num: '',
      historyList: [],
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2099, 10, 1),
      currentDate: new Date(),
      show: false,
      thisMonth: '',
      startEndDate: '',
      startDate: '',
      endDate: '',
      columns: ['全部', '支出', '收入'],
      showStatus: false,
      thisStatus: '全部',
      status: '0',
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      finished: false,
      loading: false
    };
  },
  mounted() {
    this.getMonth();
    this.historyCode();
  },
  methods: {
    toDate,
    getMoney,
    toDetail(item) {
      this.$router.push({
        name: 'RechargeDetail',
        query: {
          item: JSON.stringify(item)
        }
      });
    },
    toHome() {
      this.$router.back();
    },
    async historyCode() {
      const params = {
        id: this.$store.getters.userId,
        status: this.status,
        startDate: this.startDate,
        endDate: this.endDate,
        ...this.pagination
      };
      const res = await getHistory({
        ...params
      });
      if (res.code === 0) {
        if (this.pagination.current === 1) {
          this.historyList = res.data.records;
        } else {
          res.data.records.map((item) => {
            this.historyList.push(item);
          });
        }
        this.pagination = {
          current: res.data.current,
          size: res.data.size,
          total: res.data.total
        };
        setTimeout(() => {
          this.loading = false;
        }, 1000);
      }
    },

    load() {
      this.historyList.push(this.historyList);
    },

    onLoad() {
      if (
        this.pagination.current * this.pagination.size >=
        this.pagination.total
      ) {
        this.finished = true;
      } else {
        this.pagination = {
          current: this.pagination.current + 1,
          size: this.pagination.size,
          total: this.pagination.total
        };
        this.historyCode();
      }
    },

    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      }
      return val;
    },

    handleChangeDate() {
      this.show = true;
    },

    newDate(time) {
      const date = new Date(time);
      const year = date.getFullYear();
      let month = date.getMonth() + 1;
      month = month < 10 ? '0' + month : month;
      let day = date.getDate();
      day = day < 10 ? '0' + day : day;
      return year + '-' + month + '-' + day;
    },

    // 获取当月（第一天和最后一天）
    getThisMonth(year, month) {
      month = month - 1;
      const startDate = new Date(year, month, 1);
      const endDate = new Date(year, month + 1, 0);
      return {
        startDate: this.newDate(startDate),
        endDate: this.newDate(endDate)
      };
    },

    // 获取当前月份
    getMonth() {
      const currentDate = new Date();
      const year = new Date().getFullYear();
      this.thisMonth = ('0' + (currentDate.getMonth() + 1)).slice(-2);
      this.startDate = this.getThisMonth(year, this.thisMonth).startDate;
      this.endDate = this.getThisMonth(year, this.thisMonth).endDate;
    },

    handleSelectDate(val) {
      this.startEndDate = this.getThisMonth(
        this.newDate(val).split('-')[0],
        this.newDate(val).split('-')[1]
      );
      this.startDate = this.startEndDate.startDate;
      this.endDate = this.startEndDate.endDate;
      this.thisMonth = this.startEndDate.startDate.slice(5, 7);
      this.show = false;
      this.pagination.current = 1;
      this.historyCode();
      this.finished = false;
    },

    handleCancelDate() {
      this.pagination.current = 1;
      this.historyCode();
      this.show = false;
    },

    handleChangeStatus() {
      this.showStatus = true;
    },

    onConfirm(value, index) {
      this.thisStatus = value;
      this.showStatus = false;
      if (value === '全部') {
        this.status = '0';
      } else if (value === '收入') {
        this.status = '1';
      } else {
        this.status = '2';
      }
      this.pagination.current = 1;
      this.historyCode();
      this.finished = false;
    },

    onCancel() {
      this.pagination.current = 1;
      this.showStatus = false;
      this.finished = false;
      this.historyCode();
    }
  }
};
</script>

<style scoped lang="scss">
.container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .filter-content {
    background: #fff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    line-height: 40px;
    height: 40px;
    align-items: center;
    color: #666666;
    font-size: 18px;
    box-sizing: border-box;
    padding: 16px;
    .date-filter {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .status-filter {
      width: 85px;
      padding: 5px 0px;
      box-sizing: border-box;
      .status-item {
        position: relative;
        border: 1px #f7f7f7 solid;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        height: 32px;
        line-height: 32px;
        padding: 0 10px;
        background: #f7f7f7;
        align-items: center;
        box-sizing: border-box;
      }
    }
    .arrow-img {
      height: 20px;
      width: 20px;
      margin-left: 4px;
    }
  }
  .recharge-content {
    flex: 1;
    margin-top: 10px;
    overflow: auto;
  }
}

.item {
  display: flex;
  flex-direction: column;
  padding-left: 16px;
  background-color: #fff;
  margin-bottom: 15px;
  .time,
  .count,
  .status {
    padding: 14px 16px 14px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    .label {
      line-height: 1;
    }
    &::after {
      position: absolute;
      content: '';
      width: 100%;
      height: 1px;
      background-color: #eee;
      left: 0;
      bottom: 0;
      transform: scaleY(0.5);
    }
    /* status不要伪元素 */
    &:nth-child(3)::after {
      display: none;
    }
  }
  .time {
    color: #666666;
    font-size: 16px;
    font-weight: 400;
    img {
      width: 19px;
      height: 19px;
    }
  }
  .count {
    color: #333;
    font-size: 16px;
    .value {
      color: #ce4036;
      font-size: 16px;
      font-weight: 400;
    }
    .refund {
      color: #1b8561;
    }
  }
  .status {
    color: #333333;
    font-size: 16px;
    font-weight: 400;
    .value {
      height: 21px;
      border-radius: 4px;
      font-size: 13px;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 4px 8px;
    }
    .success {
      background: #0cc935;
    }
    .fail {
      background: #ed3844;
    }
    .ing {
      background: #ffa900;
    }
    .reject {
      background-color: #fe827a;
    }
    .unknown {
      color: #666;
      background: #e5e5e5;
    }
  }
}

::v-deep .van-picker__toolbar {
  height: 50px;
  background-color: #f1f1f1;
  .van-picker__cancel {
    font-size: 16px;
    font-weight: 500;
    color: #666666;
    font-family: 'PingFangSC-Regular, sans-serif';
  }
  .van-picker__confirm {
    font-size: 16px;
    font-weight: 500;
    color: #ffa900;
    font-family: 'PingFangSC-Regular, sans-serif';
  }
}
::v-deep .van-picker-column__item {
  height: 40px;
  line-height: 40px;
  font-size: 18px;
  color: #333333;
  font-family: 'PingFangSC-Regular, sans-serif';
}
</style>
